export const SERVER_URL = 'https://v1.traceup.rw';
// export const SERVER_URL = 'http://127.0.0.1:8000';
